import invariant from 'invariant';
import { fetch, buildUrl } from 'domain/Api';
import { AttendanceStatus } from 'data/SessionsAttendance/status';
import { List } from 'immutable';
import { ApiCall } from 'omni-common-ui';

export const FETCH_SESSION_ATTENDANCE_REQUEST = 'FETCH_SESSION_ATTENDANCE_REQUEST';
export const FETCH_SESSION_ATTENDANCE_SUCCESS = 'FETCH_SESSION_ATTENDANCE_SUCCESS';
export const FETCH_SESSION_ATTENDANCE_FAILURE = 'FETCH_SESSION_ATTENDANCE_FAILURE';
export const FETCH_GROUP_ATTENDANCE_REQUEST = 'FETCH_GROUP_ATTENDANCE_REQUEST';
export const FETCH_GROUP_ATTENDANCE_SUCCESS = 'FETCH_GROUP_ATTENDANCE_SUCCESS';
export const FETCH_GROUP_ATTENDANCE_FAILURE = 'FETCH_GROUP_ATTENDANCE_FAILURE';
export const SUBMIT_SESSION_ATTENDANCE_REQUEST = 'SUBMIT_SESSION_ATTENDANCE_REQUEST';
export const SUBMIT_SESSION_ATTENDANCE_SUCCESS = 'SUBMIT_SESSION_ATTENDANCE_SUCCESS';
export const SUBMIT_SESSION_ATTENDANCE_FAILURE = 'SUBMIT_SESSION_ATTENDANCE_FAILURE';

const buildFetchSessionAttendanceUrl = (id) => buildUrl(`/attendance/${id}`);

export function fetchSessionAttendanceIfNeeded(id) {
  invariant(id && id.length, 'id should exist and be non-empty');
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchSessionAttendanceUrl(id) })) {
      return false;
    }

    return dispatch(fetchSessionAttendance(id));
  };
}

export function fetchSessionAttendance(id) {
  return (dispatch) => {
    const url = buildFetchSessionAttendanceUrl(id);
    const method = 'GET';

    return dispatch(fetchSessionAttendanceRequest()).payload
      .then((response) => dispatch(fetchSessionAttendanceSuccess(response)))
      .catch((error) => dispatch(fetchSessionAttendanceFailure(error)));

    function fetchSessionAttendanceRequest() {
      return ApiCall.createAction({
        type: FETCH_SESSION_ATTENDANCE_REQUEST,
        payload: fetch(url),
        url,
        method,
        id,
      });
    }

    function fetchSessionAttendanceSuccess(session) {
      return ApiCall.createAction({
        type: FETCH_SESSION_ATTENDANCE_SUCCESS,
        payload: session,
        url,
        method,
        id,
      });
    }

    function fetchSessionAttendanceFailure(error) {
      return ApiCall.createAction({
        type: FETCH_SESSION_ATTENDANCE_FAILURE,
        error,
        url,
        method,
        id,
      });
    }
  };
}

const buildFetchGroupAttendanceUrl = (id) => buildUrl(`/groups/${id}/student-attendances`);

export function fetchGroupAttendanceIfNeeded(id) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchGroupAttendanceUrl(id) })) {
      return false;
    }

    return dispatch(fetchGroupAttendance(id));
  };
}

export function fetchGroupAttendance(id) {
  return (dispatch) => {
    const url = buildFetchGroupAttendanceUrl(id);
    const method = 'GET';

    return dispatch(fetchGroupAttendanceRequest()).payload
      .then((response) => dispatch(fetchGroupAttendanceSuccess(response)))
      .catch((error) => dispatch(fetchGroupAttendanceFailure(error)));

    function fetchGroupAttendanceRequest() {
      return ApiCall.createAction({
        type: FETCH_GROUP_ATTENDANCE_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchGroupAttendanceSuccess(session) {
      return ApiCall.createAction({
        type: FETCH_GROUP_ATTENDANCE_SUCCESS,
        payload: session,
        url,
        method,
      });
    }

    function fetchGroupAttendanceFailure(error) {
      return ApiCall.createAction({
        type: FETCH_GROUP_ATTENDANCE_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}

export function submitSessionAttendance(id, originalAttendance) {
  let attendance = originalAttendance;
  if (List.isList(attendance)) {
    attendance = attendance.toArray();
  }

  attendance = attendance.map((student) => ({
    studentId: student.studentGeneralInfo.id,
    attendanceStatus: AttendanceStatus[student.attendanceStatus],
  }));

  return (dispatch) => {
    const url = buildUrl(`/attendance/${id}`);
    const method = 'PUT';

    return dispatch(submitSessionAttendanceRequest()).payload
      .then((response) => dispatch(submitSessionAttendanceSuccess(response)))
      .catch((error) => dispatch(submitSessionAttendanceFailure(error)))
      .then(() => dispatch(fetchSessionAttendance(id)));

    function submitSessionAttendanceRequest() {
      const request = fetch(url,
        {
          method,
          body: JSON.stringify(attendance),
        }
      );
      return ApiCall.createAction({
        type: SUBMIT_SESSION_ATTENDANCE_REQUEST,
        payload: request,
        url,
        method,
        id,
        attendance,
      });
    }

    function submitSessionAttendanceSuccess(response) {
      return ApiCall.createAction({
        type: SUBMIT_SESSION_ATTENDANCE_SUCCESS,
        url,
        method,
        payload: response,
      });
    }

    function submitSessionAttendanceFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_SESSION_ATTENDANCE_FAILURE,
        url,
        method,
        error,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/SessionsAttendance/actions.js